import { Button, Modal } from "@/components/ui";
import { Textfield } from "../../ui/input/textfield";
import { useFormik } from "formik";
import {
  SignUpRequestInit,
  SignUpRequest,
} from "@/model/request/auth/SignUpRequest";
import { useState } from "react";
import { EyeClosed, EyeIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { signupSchema } from "@/utilities/validation/authSchema";
import { auth, AuthState } from "@/store/modules/auth";
import { RouteConstant } from "@/util/constant/RouteConstant";
import { StoreUtil } from "@/util/store/StoreUtil";
import { notification } from "@/store/modules/notification";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "@/store";

export const SignUpForm = () => {
  const authState = useSelector<any>((state) => state.auth) as AuthState;
  const [modalVisible, setModalVisible] = useState(false);
  const [response, setResponse] = useState("");
  const navigate = useNavigate();
  const [seePassword, setSeePassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(false);
  const dispatch = useDispatch<AppDispatch>();

  function gotoSuccess() {
    navigate(RouteConstant.auth.otp.path);
  }




  const handleSubmit = async (value: SignUpRequest) => {
    const request = { ...value };
    await dispatch<any>(
      auth.action.signup({
        data: request,
        onSuccess: () => gotoSuccess(),
        onError: (response) => {
          setModalVisible(true), setResponse(response.responseMessage);
        },
      })
    );
    dispatch(auth.mutation.setUserEmail(value.userEmail));
    dispatch(auth.mutation.setUserName(value.userFullName));
  };

  const formik = useFormik({
    initialValues: SignUpRequestInit,
    onSubmit: handleSubmit,
    validationSchema: signupSchema,
  });

  return (
    <div className="p-5 space-y-5">
      <form onSubmit={formik.handleSubmit}>
        {" "}
        {/* Wrap form elements with <form> */}
        <Textfield
          label="Full Name"
          name="userFullName"
          placeholder="Enter your full name"
          error={formik.errors.userFullName}
          formik={formik}
        />
        <Textfield
          label="Email"
          name="userEmail"
          placeholder="Enter your email"
          error={formik.errors.userEmail}
          formik={formik}
        />
        <Textfield
          label="Password"
          name="userPassword"
          placeholder="Enter your password"
          error={formik.errors.userPassword}
          formik={formik}
          suffixIcon={
            <button onClick={() => setSeePassword((prev) => !prev)}>
              {seePassword ? (
                <EyeIcon color="black" />
              ) : (
                <EyeClosed color="black" />
              )}
            </button>
          }
          type={seePassword ? "text" : "password"}
        />
        <Textfield
          label="Confirm Password"
          name="confirmPassword"
          placeholder="Confirm your password"
          error={formik.errors.confirmPassword}
          formik={formik}
          type={confirmPassword ? "text" : "password"}
          suffixIcon={
            <button onClick={() => setConfirmPassword((prev) => !prev)}>
              {confirmPassword ? (
                <EyeIcon color="black" />
              ) : (
                <EyeClosed color="black" />
              )}
            </button>
          }
        />
        <Button
          label="Sign up"
          className="w-full mt-5"
          state="primary"
          type="submit"
          isLoading={authState.loading}
          disabled={authState.loading || !formik.isValid}
        />
      </form>
      <Modal
        title="Signup Failed"
        text={response}
        type="error"
        modal={modalVisible}
        onClose={() => setModalVisible(false)}
        buttonLabel="Close"
        onClick={() => setModalVisible(false)}
      />
    </div>
  );
};
